// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".foraUso{background-color:#dc3545}.emUso,.foraUso{color:#fff;font-weight:700;text-align:center}.emUso{background-color:#28a745}.p-picklist-buttons.p-picklist-target-controls,.p-picklist-source-controls{display:none!important}", ""]);
// Exports
module.exports = exports;
